module.exports = __webpack_public_path__ + "static/media/home_banner2.06e6a3bf.png";